import React from "react";
import PropTypes from "prop-types";
import { Modal, Button, Form } from "react-bootstrap";

const OtpModal = ({
  show,
  onHide,
  otp,
  otpRefs,
  otpKeys,
  handleOtpChange,
  handleOtpKeyDown,
  handleOtpSubmit,
  handleRequestOtp,
  otpRequested
}) => {
  return (
    <Modal show={show} onHide={onHide} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{otpRequested ? "Enter OTP" : "Request OTP"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <p className="text-muted mb-4">
          {otpRequested
            ? "Enter the 6-digit OTP sent to your email. You can request a new OTP every 2 minutes."
            : "Click below to request a One-Time Password (OTP) to log in."}
        </p>
        {!otpRequested ? (
          <div className="text-center mt-4">
            <Button variant="primary" onClick={handleRequestOtp} className="w-100 py-2">
              Request OTP Now
            </Button>
          </div>
        ) : (
          <>
            <Form onSubmit={handleOtpSubmit}>
              <Form.Group className="mb-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <Form.Label className="fw-bold mb-0">
                    Enter OTP
                  </Form.Label>
                  <Button variant="link" size="sm" onClick={handleRequestOtp} className="p-0 text-decoration-underline">
                    Request new OTP
                  </Button>
                </div>
                <div className="d-flex justify-content-between gap-2">
                  {otpKeys.map((key, index) => (
                    <input
                      key={`otp-input-${key}`}
                      type="text"
                      inputMode="numeric"
                      pattern="\d{1}"
                      maxLength="1"
                      ref={(ref) => (otpRefs.current[index] = ref)}
                      value={otp[index] || ""}
                      onChange={(e) => handleOtpChange(e, index)}
                      onKeyDown={(e) => handleOtpKeyDown(e, index)}
                      className="form-control form-control-lg text-center"
                      style={{
                        fontSize: "1.5rem",
                      }}
                      aria-label={`OTP Digit ${index + 1}`}
                    />
                  ))}
                </div>
              </Form.Group>
              {/* Change justify-content-end to justify-content-between */}
              <div className="d-flex justify-content-between gap-2">
                <Button variant="outline-secondary" onClick={onHide}>
                  Cancel
                </Button>
                <Button type="submit" variant="primary">
                  Login with OTP
                </Button>
              </div>
            </Form>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

OtpModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  otp: PropTypes.array.isRequired,
  otpRefs: PropTypes.object.isRequired,
  otpKeys: PropTypes.array.isRequired,
  handleOtpChange: PropTypes.func.isRequired,
  handleOtpKeyDown: PropTypes.func.isRequired,
  handleOtpSubmit: PropTypes.func.isRequired,
  handleRequestOtp: PropTypes.func.isRequired,
  otpRequested: PropTypes.bool.isRequired,
};

export default OtpModal;
